<div
    aria-live="polite"
    class="app-label-badge app-label-badge--row-delete"
    role="status"
    [attr.data-variant]="variant()"
    [class.app-label-badge--icon-only]="!hasLabel()"
    [matTooltip]="tooltip()">
    @if (iconPosition() === LabelIconPosition.START) {
        @if (baseIcon() && topIcon()) {
            <app-stack-icons
                [baseIcon]="baseIcon()!"
                [baseIconTransform]="baseIconTransform()"
                [size]="iconSize()"
                [topIcon]="topIcon()!"
                [topIconTransform]="topIconTransform()" />
        } @else if (baseIcon()) {
            <fa-icon
                class="shrink-0"
                [icon]="baseIcon()!"
                [size]="iconSize()" />
        }
    }

    <span class="label-style truncate">{{ label() }}</span>

    @if (iconPosition() === LabelIconPosition.END) {
        @if (baseIcon() && topIcon()) {
            <app-stack-icons
                [baseIcon]="baseIcon()!"
                [baseIconTransform]="baseIconTransform()"
                [size]="iconSize()"
                [topIcon]="topIcon()!"
                [topIconTransform]="topIconTransform()" />
        } @else if (baseIcon()) {
            <fa-icon
                class="shrink-0"
                [icon]="baseIcon()!"
                [size]="iconSize()" />
        }
    }

    @if (canClose()) {
        <fa-icon
            class="cursor-pointer"
            [icon]="['fas', 'xmark']"
            (click)="close.emit()" />
    }
</div>
